/* eslint-disable */

(function () {
  var $lastOpened = false;

  $(document).click(function () {
    if ($lastOpened) {
      $lastOpened.removeClass('open');
    }
  });

  $(document).on('click', '.pulldown-toggle', function (event) {

    var el = $(event.currentTarget);

    event.preventDefault();
    event.stopPropagation();

    if (el.hasClass('open')) {
      el.removeClass('open');
    } else {
      if ($lastOpened) {
        $lastOpened.removeClass('open');
      }
      el.addClass('open');
      $lastOpened = el;
    }

  });
})();
